import { useState } from 'react';

/**
 * Copies the provided value into the clipboard.
 * @returns An object containing the function to perform the copy and the status of the copy.
 */
const useClipboardCopy = () => {
  const [wasCopied, setWasCopied] = useState(false);

  const copyToClipboard = (valueToCopy: string) => {
    navigator.clipboard.writeText(valueToCopy)
      .then(() => {
        setWasCopied(true);

        // We want to reset this value after a short interval, this operation will happen many times
        setTimeout(() => {
          setWasCopied(false);
        }, 1150);
      })
      .catch(() => setWasCopied(false));
  };

  return { copyToClipboard, wasCopied };
};

export default useClipboardCopy;
